import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SortPayload, useListController } from 'react-admin';
import { ListPage } from 'shared/react-admin/Pages';
import { Order } from 'types/embedded/order';

import { OrderAdjustmentsForm } from './OrderAdjustmentsForm/OrderAdjustmentsForm';

export const OrderAdjustmentsList = (): JSX.Element => {
  const translate = useTypedTranslate();

  const { filterValues } = useListController<Order>({
    resource: Resources.Orders,
    queryOptions: { enabled: false },
  });

  const isListFilterExist = Object.keys(filterValues).length > 0;

  return (
    <ListPage
      empty={false}
      headerTitle={{ titleText: translate('app.adjustments.massOrderAdjustment') }}
      pagination={<></>}
      queryOptions={{ enabled: isListFilterExist }}
      resource="orders"
      sort={{} as SortPayload}
    >
      <OrderAdjustmentsForm />
    </ListPage>
  );
};
